import { EagerLoadingLogoProvider } from "@insite/client-framework/Common/EagerLoadingLogo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";  // Poolcorp Custom Code
import dismissRfqUpdates from "@insite/client-framework/Store/Context/Handlers/DismissRfqUpdates";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Poolcorp Custom Code
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import React, { useEffect } from "react"; // Poolcorp Custom Code
import { connect, ResolveThunks } from "react-redux";
// import { css } from "styled-components"; // Poolcorp Custom Code

/* Poolcorp Custom Code */
import { getCookie } from "@insite/client-framework/Common/Cookies";
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getCurrentUserIsGuest, getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import Hidden from "@insite/mobius/Hidden";
import { getProp } from "@insite/mobius/utilities";
import {
    LOGO_LINK_SEARCH_NAV,
    MAIN_NAV_HEIGHT,
    MOBILE_HEADER_HEIGHT,
    SMALLEST_HEADER_HEIGHT,
} from "@store/Overrides/Widgets/Header/LogoLinksSearch";
import { SECONDARY_NAVIGATION_HEIGHT } from "@store/Overrides/Widgets/Header/SecondaryNavigation";
import { getStoreSession, getStoreSettingsCollection } from "@store/Store/Context/ContextSelectors";
import { COMMON, MENU } from "@store/theme/design";
import breakpointMediaQueries, { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import isTheme from "@store/utilities/isTheme";
import isWebsiteAccessedByMobileApp from "@store/utilities/isWebsiteAccessedByMobileApp";
import { MOBILE_INDICATOR_HEIGHT } from "@store/Widgets/BranchIndicator";
import React, { useContext, useEffect } from "react";
import styled, { css } from "styled-components";

type InjectableCssWithShell = InjectableCss & {
    isEditing?: boolean;
};
const StyledContainer = styled(StyledWrapper)<InjectableCssWithShell>``;

const mapStateToProps = (state: ApplicationState) => {
    const settings = getStoreSettingsCollection(state);
    const session = getStoreSession(state);
    
    return {
        siteName: state.context.website.name,
        session: getSession(state),
        myAccountPageUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
        // Poolcorp Custom Code
        isSignedIn: state.context.session.userName && !getCurrentUserIsGuest(state),
        rememberMe: state.context.session.rememberMe,
        disablePickupBranchSelection: settings.poolcorpSettings.disablePickupBranchSelectionByCountry,
        isFullfillmentMethodPickup: session.fulfillmentMethod === FulfillmentMethod.PickUp,
    };
};
/* Poolcorp Custom Code */

const mapDispatchToProps = {
    dismissRfqUpdates,
};

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory;

export interface HeaderStyles {
    page?: MobiusPageProps;
    container?: InjectableCss;
    skipToContent?: SkipNavStyles;
    websiteName?: InjectableCss;
    // Poolcorp Custom Code
    signedInPage?: MobiusPageProps;
    mobileAppHiddenPage?: MobiusPageProps;
}

const HEADER_HEIGHT_VALUES = [
    MOBILE_HEADER_HEIGHT,
    MOBILE_HEADER_HEIGHT,
    (MAIN_NAV_HEIGHT[2] || 0) + SECONDARY_NAVIGATION_HEIGHT,
    (MAIN_NAV_HEIGHT[3] || 0) + SECONDARY_NAVIGATION_HEIGHT,
    (MAIN_NAV_HEIGHT[4] || 0) + SECONDARY_NAVIGATION_HEIGHT,
];

const stickyCss = css`
    z-index: ${getProp("theme.zIndex.stickyFooter")};
    position: fixed;
    top: 0;
    width: 100%;
    box-shadow: ${getProp("theme.shadows.main")};
    background: ${getColor("header.main")};
`;

const logoLinkSearchNavCss = css`
    ${props =>
        breakpointValuesMediaQueries(
            props.theme,
            [{ values: LOGO_LINK_SEARCH_NAV, properties: ["height"], unit: "px" }],
            mediaOptions.min,
        )}
`;

const pageCss = css`
    overflow: visible !important; /* Required to override overflow from Mobius Page Component */

    ${props =>
        breakpointValuesMediaQueries(
            props.theme,
            [{ values: HEADER_HEIGHT_VALUES, properties: ["height"], unit: "px" }],
            mediaOptions.min,
        )}

    @media (min-width: ${COMMON.breakpoints[2]}px) {
        div[data-test-selector="NavigationDrawerSticky"] {
            transition: ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            visibility: hidden;

            button[data-test-selector="expandMobileMenu"] {
                margin-right: 1em;
                transition: ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                opacity: 0;
                margin-left: -44px;
            }
        }


    }
    div[data-test-selector="LogoZoneSticky"],
    div[data-test-selector="LogoZoneStickySmaller"] {
        img {
            box-sizing: content-box;
            transition: max-height ${getProp("theme.transition.duration.regular")}ms ease-in-out;
        }
    }

    /* Logo Desktop */
    div[data-test-selector="LogoZoneSticky"] {
        height: 100%;

        img.img {
            ${({ theme }) => {
                if (isTheme(theme, "horizon")) {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                padding-bottom: 15px;
                                max-height: calc(${LOGO_LINK_SEARCH_NAV[3]}px - 15px);
                            `,
                            css`
                                padding-bottom: 20px;
                                max-height: calc(${LOGO_LINK_SEARCH_NAV[4]}px - 20px);
                            `,
                        ],
                        "min",
                    );
                }
                return css`
                    max-height: calc(0.90 * ${MOBILE_HEADER_HEIGHT}px);
                `;
            }}
        }
    }
    /* Logo Desktop - smaller */
    div[data-test-selector="LogoZoneStickySmaller"] {
        height: 100%;
        
        img.img {
            ${({ theme }) => {
                if (isTheme(theme, "horizon")) {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                max-height: calc(${LOGO_LINK_SEARCH_NAV[2]}px - 8px);
                            `,
                            null,
                            null,
                        ],
                        "min",
                    );
                }
            }}
        }
    }

    .pageSticky {
        div[data-test-selector="NavigationDrawerSticky"] {
            width: fit-content !important;
            visibility: visible;

            button[data-test-selector="expandMobileMenu"] {
                opacity: 1;
                margin-left: 0;
            }
        }

        ${props =>
            breakpointValuesMediaQueries(
                props.theme,
                [{ values: HEADER_HEIGHT_VALUES, properties: ["height"], unit: "px" }],
                mediaOptions.min,
            )}

        ${({ theme }) => breakpointMediaQueries(theme, [null, stickyCss, null], "max")}

        div[data-test-selector="LogoLinkSearchWrapper"] {
            ${logoLinkSearchNavCss}
        }

        div[data-test-selector="LogoLinkSearch"] {
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [null, null, stickyCss], "min");
            }}
            ${logoLinkSearchNavCss}
        }
    
        /* Logo Desktop - sticky */
        div[data-test-selector="LogoZoneSticky"] {
            img.img {
                ${({ theme }) => {
                    if (isTheme(theme, "horizon")) {
                        return css`
                            padding: 4px 0 15px 0;
                            max-height: calc(${LOGO_LINK_SEARCH_NAV[3]}px - 19px);
                        `;
                    }
                    return null;
                }}
            }
        }
    
        /* Logo Desktop - smaller */
        div[data-test-selector="LogoZoneStickySmaller"] {
            img.img {
                ${({ theme }) => {
                    if (isTheme(theme, "horizon")) {
                        return css`
                            padding: 12px 0;
                            max-height: calc(${LOGO_LINK_SEARCH_NAV[2]}px - 24px);
                        `;
                    }
                    return null;
                }}
            }
        }
    }

    .pageSticky.pageStickySmaller {
        div[data-test-selector="LogoLinkSearch"],
        div[data-test-selector="MainNavigation"] {
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: [null, null, SMALLEST_HEADER_HEIGHT, null, null], properties: ["height"], unit: "px" }],
                    mediaOptions.min,
                )}
        }
    
        /* Logo Desktop - sticky */
        div[data-test-selector="LogoZoneSticky"] {
            img.img {
                ${({ theme }) => {
                    if (isTheme(theme, "horizon")) {
                        return css`
                            max-height: calc(${SMALLEST_HEADER_HEIGHT}px - 14px);
                        `;
                    }
                    return null;
                }}
            }
        }
    
        /* Logo Desktop - smaller */
        div[data-test-selector="LogoZoneStickySmaller"] {
            img.img {
                ${({ theme }) => {
                    if (isTheme(theme, "horizon")) {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                padding-top: 4px;
                                max-height: calc(${SMALLEST_HEADER_HEIGHT}px - 8px);
                            `,
                            null,
                            null,
                        ],
                        "min",
                    );
                    }
                    return null;
                }}
            }
        }
    }
`;

export const headerStyles: HeaderStyles = {
    page: {
        css: pageCss,
    },
    signedInPage: {
        css: css`
            ${pageCss}
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: [HEADER_HEIGHT_VALUES[0]+MOBILE_INDICATOR_HEIGHT, HEADER_HEIGHT_VALUES[1]+MOBILE_INDICATOR_HEIGHT, HEADER_HEIGHT_VALUES[2], HEADER_HEIGHT_VALUES[3], HEADER_HEIGHT_VALUES[4], ], properties: ["height"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    mobileAppHiddenPage: {
        css: css`
            display: none;
        `,
    },
    container: {
        css: css<InjectableCssWithShell>`
            background-color: ${getColor("header.main")};
            color: ${getColor("header.contrastMain")};
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        null,
                        css`
                            display: flex;
                            ${!props.isEditing
                                ? css`
                                      height: 50px;
                                  `
                                : null}
                            border-bottom: 1px solid ${getColor("common.border")};
                            font-size: 20px;

                            > div {
                                width: auto;

                                &:first-child {
                                    order: 2;
                                }

                                &:last-child {
                                    flex-grow: 1;
                                }
                            }
                        `,
                    ],
                    mediaOptions.max,
                )}
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        {
                            values: COMMON.spacing.side
                                .slice(0, 2)
                                .map(x => (x ? `calc(${x} - ${MENU.mobileButtonSpacing})` : x)),
                            properties: ["padding-right", "padding-left"],
                        },
                    ],
                    mediaOptions.minMax,
                )}
        `,
    },
    websiteName: {
        css: css`
            @media print {
                display: block;
            }
            font-size: 12px;
            padding-left: 15px;
            display: none;
        `,
    },
};

const styles = headerStyles;

const Header = ({ 
    id, 
    siteName, 
    session, 
    toaster, 
    history, 
    myAccountPageUrl, 
    dismissRfqUpdates,
    // Poolcorp Custom Code
    isSignedIn,
    rememberMe,
    disablePickupBranchSelection,
    isFullfillmentMethodPickup,
}: Props) => {
    /* Poolcorp Custom Code */
    const { isEditing } = useContext(ShellContext);
    const [scrollInit, setScrollInit] = React.useState(false);
    const [currenctScrollTop, setCurrenctScrollTop] = React.useState(0);
    const [isSticky, setIsSticky] = React.useState(false);
    const [isStickySmall, setIsStickySmall] = React.useState(false);
    const [firstScrollLimit, setFirstScrollLimit] = React.useState(0);
    const [secondScrollLimit, setSecondScrollLimit] = React.useState(0);
    const [headerClassNames, setHeaderClassNames] = React.useState("");

    const isAppMobileView = isWebsiteAccessedByMobileApp();
    const isNotPickupBranchSelectionDisabled = !(disablePickupBranchSelection && isFullfillmentMethodPickup);

    const initScrollValues = () => {
        const currentWidth = window.innerWidth;

        if (currentWidth < COMMON.breakpoints[1]) {
            setFirstScrollLimit(1);
            setSecondScrollLimit(1);
            setIsSticky(true);
        } else if (currentWidth < COMMON.breakpoints[2]) {
            setFirstScrollLimit(1);
            setSecondScrollLimit(1);
            setIsSticky(true);
        } else if (currentWidth < COMMON.breakpoints[3]) {
            setFirstScrollLimit(SECONDARY_NAVIGATION_HEIGHT);
            setSecondScrollLimit(HEADER_HEIGHT_VALUES[2] - SMALLEST_HEADER_HEIGHT);
        } else if (currentWidth < COMMON.breakpoints[4]) {
            setFirstScrollLimit(SECONDARY_NAVIGATION_HEIGHT);
            setSecondScrollLimit(HEADER_HEIGHT_VALUES[3] - SMALLEST_HEADER_HEIGHT);
        } else {
            setFirstScrollLimit(SECONDARY_NAVIGATION_HEIGHT);
            setSecondScrollLimit(HEADER_HEIGHT_VALUES[4] - SMALLEST_HEADER_HEIGHT);
        }
        handleScroll();
    };
    const handleResize = () => {
        initScrollValues();
    };
    const handleScroll = () => {
        setCurrenctScrollTop(document.body.scrollTop || document.documentElement.scrollTop);
    };
    useEffect(() => {
        if (currenctScrollTop > firstScrollLimit) {
            setIsSticky(true);
            setIsStickySmall(currenctScrollTop > secondScrollLimit);
        } else if (firstScrollLimit > 0) {
            setIsSticky(false);  
        }
    }, [currenctScrollTop, firstScrollLimit, secondScrollLimit]);

    useEffect(() => {
        let _headerClassNames = isSticky ? "pageSticky" : "";
        _headerClassNames = _headerClassNames + (isStickySmall ? " pageStickySmaller" : "");
        setHeaderClassNames(_headerClassNames);
    }, [isSticky, isStickySmall]);

    useEffect(() => {
        if (scrollInit) {
            handleScroll();
        }
    }, [firstScrollLimit, secondScrollLimit]);
    /* Poolcorp Custom Code */

    const viewMyDashboardClickHandler = () => {
        if (myAccountPageUrl) {
            history.push(myAccountPageUrl);
        }
    };

    useEffect(() => {
        /* Poolcorp Custom Code */
        if (typeof window === "undefined") {
            return;
        }
        initScrollValues();
        setScrollInit(true);
        window.addEventListener("resize", handleResize, true);
        window.addEventListener("scroll", handleScroll);
        /* Poolcorp Custom Code */
        if (session.hasRfqUpdates && myAccountPageUrl) {
            toaster.addToast({
                body: (
                    <>
                        <Typography>{translate("You have new quote information.")}</Typography>
                        <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
                    </>
                ),
                messageType: "info",
                timeoutLength: 1000 * 60 * 60 * 24 * 365,
                onClose: () => {
                    dismissRfqUpdates();
                },
            });
        }
        /* Poolcorp Custom Code */
        return function cleanup() {
            window.removeEventListener("resize", handleResize, true);
            window.removeEventListener("scroll", handleScroll);
        };
        /* Poolcorp Custom Code */
    }, [myAccountPageUrl]);

    const afterHeader = React.createRef<HTMLSpanElement>();

    const desktopStyles = (isSignedIn || rememberMe) && isNotPickupBranchSelectionDisabled ? styles.signedInPage : styles.page; // Poolcorp Custom Code

    return (
        <Page
            as="header"
            isHeader={true}
            // Poolcorp Custom Code
            {...(isAppMobileView ? styles.mobileAppHiddenPage : (desktopStyles))}
        >
            <StyledWrapper className={headerClassNames}>
                <SkipNav
                    extendedStyles={styles.skipToContent}
                    text={translate("Skip to main content")}
                    destination={afterHeader}
                />
                <EagerLoadingLogoProvider value={true}>
                    <Hidden below="md">
                        <Zone contentId={id} zoneName="SecondaryNavigation" />
                    </Hidden>
                    {/* Poolcorp Custom Code */}
                    <StyledContainer
                        {...styles.container}
                        isEditing={isEditing}
                        data-test-selector="MainNavigation"
                    >
                        <Zone contentId={id} zoneName="Header" />
                        <Zone contentId={id} zoneName="MainNavigation" />
                    </StyledContainer>
                    {(isSignedIn || rememberMe) && isNotPickupBranchSelectionDisabled ? (
                        <Hidden above="md">
                            <Zone contentId={id} zoneName="MobileBranchSelector" />
                        </Hidden>
                    ) : null}
                    {/* Poolcorp Custom Code */}
                </EagerLoadingLogoProvider>
                <span ref={afterHeader} tabIndex={-1} />
            </StyledWrapper>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(Header))),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export const HeaderContext = "HeaderContext";

export default pageModule;
